import { ResetIcon } from "../../icons/icons";

/**
 * Build styles
 */
// require('./index.css').toString();
const { make } = require("./util");

export default class FontSizeTune {
  /**
   * Default colour
   *
   * @public
   * @returns {string}
   */
  static get DEFAULT_FONT() {
    return "";
  }

  static get isTune() {
    return true;
  }

  getFontSize() {
    if (
      !!this.settings?.blocks &&
      this.settings.blocks.hasOwnProperty(this.block.name)
    ) {
      return this.settings.blocks[this.block.name];
    }
    if (!!this.settings?.default) {
      return this.settings.default;
    }
    return FontSizeTune.DEFAULT_FONT;
  }

  constructor({ api, data, config, block }) {
    this.api = api;
    this.block = block;
    this.settings = config;
    this.data = data || { fontSize: this.getFontSize() };
    this._CSS = {
      wrapper: "cdx-font-size-settings",
      button: "cdx-font-size-button",
      tuneWrapper: "editor-block-tune",
      tuneTitle: "editor-block-tune-title",
      tuneText: "editor-block-tune-text",
      tuneInput: "editor-block-tune-input",
      tuneButton: "editor-block-tune-button",
      tuneContent: "editor-block-tune-content-container",
    };
  }

  injectFontSizeStyle(fontSize) {
    const fontId = this.wrapper.dataset.fontId;
    const styleId = `font-size-style-${fontId}`;

    let styleTag = document.getElementById(styleId);
    const css = `
    [data-font-id="${fontId}"] .cdx-nested-list__item::before {
      font-size: ${fontSize} !important;
      line-height: ${fontSize} !important;
    }
    [data-font-id="${fontId}"] .cdx-nested-list__item .cdx-nested-list__item-content{
      font-size: ${fontSize} !important;
      line-height: ${fontSize} !important;
    }
  `;

    if (styleTag) {
      styleTag.innerHTML = css;
    } else {
      styleTag = document.createElement("style");
      styleTag.id = styleId;
      styleTag.innerHTML = css;
      document.head.appendChild(styleTag);
    }
  }

  removeStyleTag() {
    const fontId = this.wrapper.dataset.fontId;
    const styleId = `font-size-style-${fontId}`;
    let styleTag = document.getElementById(styleId);
    if (styleTag) {
      styleTag.remove();
    }
  }

  wrap(blockContent) {
    this.wrapper = make("div", "cdx-font-size-tune-wrapper");
    const uniqueId = `font-${Math.random().toString(36).substring(2, 8)}`;
    this.wrapper.dataset.fontId = uniqueId;

    this.wrapper.append(blockContent);

    const target = this.wrapper.querySelectorAll('[contenteditable="true"');

    target.forEach(element => {
      element.style.fontSize = `${this.data.fontSize}px`;
      if (this.block.name === "list") {
        element.style.lineHeight = `${this.data.fontSize}px`;
      }

      if (this.block.name === "list") {
        this.injectFontSizeStyle(`${this.data.fontSize}px`);
      }
    });

    return this.wrapper;
  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  render() {
    const wrapper = make("div", [this._CSS.wrapper, this._CSS.tuneWrapper]);
    const label = make("label", [this._CSS.tuneTitle]);
    const content = make("div", [this._CSS.tuneContent]);
    const fontSizeInput = make("input", [this._CSS.tuneInput]);
    const resetFontButton = make("button", [this._CSS.tuneButton, 'cdx-settings-button']);
    const targets = this.wrapper.querySelectorAll('[contenteditable="true"');

    resetFontButton.innerHTML = ResetIcon;

    if (this.settings?.enabledBlocks && this.settings?.enabledBlocks.length > 0) {

      if (!this.settings?.enabledBlocks.some((e) => e === this.block.name)) {
        fontSizeInput.disabled = true;
        resetFontButton.disabled = true;
      }
    } else {
      fontSizeInput.disabled = true;
      resetFontButton.disabled = true;
    }

    const allTargets = (_fontSize) => {
      targets.forEach((e) => {
        e.style.fontSize = _fontSize;
        if (this.block.name === "list") {
          e.style.lineHeight = _fontSize;
        }
      });
    };

    const resetFont = () => {
      allTargets("");
      this.removeStyleTag();
      fontSizeInput.value = parseFloat(
        window.getComputedStyle(
          this.wrapper.querySelector('[contenteditable="true"')
        ).fontSize
      );
      this.data.fontSize = "";
    }

    label.innerText = "Font size";
    fontSizeInput.type = "number";
    fontSizeInput.min = "0";
    fontSizeInput.value =
      this.data.fontSize ||
      parseFloat(
        window.getComputedStyle(
          this.wrapper.querySelector('[contenteditable="true"')
        ).fontSize
      );
    fontSizeInput.addEventListener("input", (e) => {
      if (e.target.value === "") {
        resetFont();
      } else {
        const newFontSize = `${e.target.value}px`;

        allTargets(newFontSize);
        this.data.fontSize = e.target.value;

        if (this.block.name === "list") {
          this.injectFontSizeStyle(newFontSize);
        }
      }
    });

    resetFontButton.addEventListener("click", () => {
      resetFont();
    });

    content.append(fontSizeInput);
    content.append(resetFontButton);
    wrapper.append(label);
    wrapper.append(content);

    return wrapper;
  }

  save() {
    return this.data;
  }
}
